// packages/ui/src/components/Spinner/Spinner.tsx

import { cn } from '../../lib/cn';

export interface SpinnerProps {
  /** Visual size of the spinner. sm=16px, md=24px, lg=40px. */
  size?: 'sm' | 'md' | 'lg';
  /** CSS color value. Defaults to primary orange. */
  color?: string;
  /** Additional CSS class name. */
  className?: string;
  /** Accessible label for screen readers. Consumer should pass t() value. */
  'aria-label'?: string;
}

const sizeClasses: Record<NonNullable<SpinnerProps['size']>, string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-8 w-8 border-2',
};

export function Spinner({
  size = 'md',
  color,
  className,
  'aria-label': ariaLabel,
}: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={ariaLabel}
      className={cn(
        'inline-block animate-spin rounded-full border-primary-500 border-t-transparent',
        sizeClasses[size],
        className,
      )}
      style={color ? { borderColor: color, borderTopColor: 'transparent' } : undefined}
    >
      {ariaLabel && <span className="sr-only">{ariaLabel}</span>}
    </span>
  );
}
